// imports
import { fetchMuseAndroidPromoPlansApi, checkoutMuseAndroidPromoPlanApi } from 'api/museAndroidPromo';
import { notify } from 'redux/actions/notice';
import { endPoints } from 'config/routes';
import { redirectTo } from 'libs/common';
import { parseQueryString } from 'libs/auth';
// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_MUSE_ANDROID_PROMO_PLAN_START = 'FETCH_MUSE_ANDROID_PROMO_PLAN_START';
export const FETCH_MUSE_ANDROID_PROMO_PLAN_END = 'FETCH_MUSE_ANDROID_PROMO_PLAN_END';
export const SELECT_MUSE_ANDROID_PROMO_PLAN = 'SELECT_MUSE_ANDROID_PROMO_PLAN';
export const CHECKOUT_MUSE_ANDROID_PROMO_PLAN_START = 'CHECKOUT_MUSE_ANDROID_PROMO_PLAN_START';
export const CHECKOUT_MUSE_ANDROID_PROMO_PLAN_END = 'CHECKOUT_MUSE_ANDROID_PROMO_PLAN_END';
export const MUSE_ANDROID_PROMO_PLAN_ERROR = 'MUSE_ANDROID_PROMO_PLAN_ERROR';

// ------------------------------------
// Actions
// ------------------------------------
export function fetchMuseAndroidPromoPlanStart() {
  return ({ type: FETCH_MUSE_ANDROID_PROMO_PLAN_START });
}

export function fetchMuseAndroidPromoPlanEnd(payload) {
  return ({ type: FETCH_MUSE_ANDROID_PROMO_PLAN_END, payload });
}

export function checkoutMuseAndroidPromoPlanStart() {
  return ({ type: CHECKOUT_MUSE_ANDROID_PROMO_PLAN_START });
}

export function checkoutMuseAndroidPromoPlanEnd() {
  return ({ type: CHECKOUT_MUSE_ANDROID_PROMO_PLAN_END });
}

export function raiseErrorMuseAndroidPromoPlan(payload) {
  return ({ type: MUSE_ANDROID_PROMO_PLAN_ERROR, payload });
}

export function selectMuseAndroidPromoPlan(payload) {
  return ({ type: SELECT_MUSE_ANDROID_PROMO_PLAN, payload });
}

export function checkoutMuseAndroidPromoPlan(plan, payload, done = () => { }) {
  return (dispatch, getState) => {
    const { i18n: { info: { locale } } } = getState();
    dispatch(selectMuseAndroidPromoPlan(plan));
    dispatch(checkoutMuseAndroidPromoPlanStart());
    checkoutMuseAndroidPromoPlanApi(payload, locale)
      .then((res = {}) => {
        const resBody = res.body;
        done(null, resBody);
        dispatch(checkoutMuseAndroidPromoPlanEnd());
      })
      .catch((error) => {
        dispatch(notify({ error }));
        dispatch(checkoutMuseAndroidPromoPlanEnd());
        done(error);
      });
  };
}

export function loadMuseAndroidPromoPlan(country, coupon) {
  return (dispatch) => {
    dispatch(fetchMuseAndroidPromoPlanStart());
    // api call
    fetchMuseAndroidPromoPlansApi(country, coupon)
      .then((res) => {
        dispatch(fetchMuseAndroidPromoPlanEnd(res.body));
      })
      .catch((error) => {
        const { statusCode } = error.response;
        if (statusCode === 404) {
          const { country_code } = parseQueryString();
          const query = country_code ? `?country_code=${country_code}` : '';
          redirectTo(endPoints.products.muse.trial, query);
        } else {
          const { message } = error.response.body;
          dispatch(notify({ error }));
          dispatch(raiseErrorMuseAndroidPromoPlan(message));
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/museAndroidPromo.js